import React from "react";
import PropTypes from "prop-types";
import Timer from "react-compound-timer";
import "./TimeCounter.scss";

function TimeCounter(props) {
  const { className, initialTime } = props;
  const formatValue = (value) => {
    return value < 10 ? `0${value}` : value;
  };
  return (
    <div className={`time-counter ${className}`} data-testid="time-counter">
      <Timer  formatValue={formatValue} initialTime={initialTime}>
        <Timer.Hours /> : <Timer.Minutes /> : <Timer.Seconds />
      </Timer>
    </div>
  );
}

TimeCounter.propTypes = {
  className: PropTypes.string,
  initialTime: PropTypes.number,
};
TimeCounter.defaultProps = {
  className: "",
  initialTime: 0,
};

export default TimeCounter;
